import styled from 'styled-components';

import type {
  MenuComponent,
} from '@n3/react-autocomplete';

export const Menu: MenuComponent = styled.div(({
  theme: {
    colors,
  },
}) => ({
  boxSizing: 'border-box',
  position: 'absolute',
  top: '100%',
  width: '100%',
  zIndex: 1,
  marginTop: 4,
  maxHeight: 200,
  overflowY: 'auto',
  borderRadius: 4,
  backgroundColor: colors.NEUTRAL_WHITE,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: colors.NEUTRAL_INACTIVE,
  boxShadow: '0px 4px 8px rgba(148, 148, 148, 0.24)',
  padding: '12px 0',
}));
